"use client";

import { c as _c } from "react/compiler-runtime";
import { Progress, ProgressColor } from "@workspace/ui/components";
import { usePathname, useRouter } from "next/navigation";
import { useEffect } from "react";
import { accountRoutes, authRoutes } from "@/const/routes";
import { useCustomer } from "@/context";
const ProtectedRoutes = t0 => {
  const $ = _c(22);
  const {
    children
  } = t0;
  const {
    state: t1
  } = useCustomer();
  const {
    isLoggedIn,
    isLoadingAccountInfo
  } = t1;
  const router = useRouter();
  const pathname = usePathname();
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [accountRoutes.NEW_ADDRESS, accountRoutes.PERSONAL_DATA, accountRoutes.ACCOUNT];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const exactPaths = t2;
  let authPaths;
  let t3;
  if ($[1] !== pathname) {
    const basePaths = [accountRoutes.ADDRESSES, accountRoutes.RETURN_FORM, accountRoutes.ORDERS_HISTORY, accountRoutes.RETURN_PRODUCTS];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = [authRoutes.SIGN_IN, authRoutes.SIGN_UP, authRoutes.RESET_PASSWORD];
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    authPaths = t4;
    t3 = exactPaths.includes(pathname) || basePaths.some(basePath => pathname.startsWith(basePath));
    $[1] = pathname;
    $[2] = authPaths;
    $[3] = t3;
  } else {
    authPaths = $[2];
    t3 = $[3];
  }
  const isAccountRoutes = t3;
  const isAuthRoutes = authPaths.includes(pathname);
  let t4;
  if ($[5] !== isAccountRoutes || $[6] !== isAuthRoutes || $[7] !== isLoggedIn || $[8] !== router) {
    t4 = () => {
      if (!isLoggedIn && isAccountRoutes) {
        router.push(authRoutes.SIGN_IN);
      } else {
        if (isLoggedIn && isAuthRoutes) {
          router.push(accountRoutes.ACCOUNT);
        }
      }
    };
    $[5] = isAccountRoutes;
    $[6] = isAuthRoutes;
    $[7] = isLoggedIn;
    $[8] = router;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== isAccountRoutes || $[11] !== isAuthRoutes || $[12] !== isLoggedIn || $[13] !== pathname || $[14] !== router) {
    t5 = [pathname, isLoggedIn, isAccountRoutes, isAuthRoutes, router];
    $[10] = isAccountRoutes;
    $[11] = isAuthRoutes;
    $[12] = isLoggedIn;
    $[13] = pathname;
    $[14] = router;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  useEffect(t4, t5);
  let t6;
  if ($[16] !== children || $[17] !== isAccountRoutes || $[18] !== isAuthRoutes || $[19] !== isLoadingAccountInfo || $[20] !== isLoggedIn) {
    t6 = !isLoggedIn && isAccountRoutes || isLoggedIn && isAuthRoutes || isLoadingAccountInfo ? <div className="flex justify-center items-center h-screen"><Progress color={ProgressColor.GRAYSCALE_400} /></div> : children;
    $[16] = children;
    $[17] = isAccountRoutes;
    $[18] = isAuthRoutes;
    $[19] = isLoadingAccountInfo;
    $[20] = isLoggedIn;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
};
export default ProtectedRoutes;